import { put } from 'redux-saga/effects'

import { Deals } from 'services/api/entities'
import { AdvisorDealsActionCreators } from 'app/reducers/AdvisorDealsRedux'

export function* getAdvisorDealsRequest({ params }) {
  const response = yield Deals.getAll(params)

  if (response.success()) {
    // pagination_class is None on this endpoint: the payload IS the array
    return yield put(
      AdvisorDealsActionCreators.getAdvisorDealsSuccess(response.data || []),
    )
  }
  yield put(AdvisorDealsActionCreators.getAdvisorDealsFailure(response.data))
}
